import { createSlice } from "@reduxjs/toolkit";
import { getAllDataProjectManagement } from "./allDataProjectManagement.thunk";
import { SERVICE_TABS } from "../../constant/constant";
import {
  allDataProjectManagementInitialState,
  getAllDataProjectManagementServiceSlice,
} from "./allDataProjectManagement.utils";

export const checkAllFetched = (isFetching) => {
  return Object.values(isFetching).every((status) => status === false);
};

const AllDataProjectManagementSlice = createSlice({
  name: "allDataProjectManagement",
  initialState: allDataProjectManagementInitialState,

  reducers: {
    updateProjectData: (state, action) => {
      // const { status, data } = action.payload;
      // state.allProjectList.data[status] = data.data;
      // state.allProjectList.error[status] = null;

      const { status, data, serviceType = SERVICE_TABS.video } = action.payload;

      const serviceSlice = getAllDataProjectManagementServiceSlice(
        state,
        serviceType
      );

      if (!serviceSlice) return;

      serviceSlice.data[status] = data.data;
      serviceSlice.error[status] = null;
    },
    updateProjectError: (state, action) => {
      // const { status, error } = action.payload;
      // state.allProjectList.error[status] = error;

      const {
        status,
        error,
        serviceType = SERVICE_TABS.video,
      } = action.payload;
      const serviceSlice = getAllDataProjectManagementServiceSlice(
        state,
        serviceType
      );

      if (!serviceSlice) return;

      serviceSlice.error[status] = error;
    },
    updateFetchingStatus: (state, action) => {
      // const { status, isFetching } = action.payload;
      // state.allProjectList.isFetching[status] = isFetching;

      const {
        status,
        isFetching,
        serviceType = SERVICE_TABS.video,
      } = action.payload;
      const serviceSlice = getAllDataProjectManagementServiceSlice(
        state,
        serviceType
      );

      if (!serviceSlice) return;

      serviceSlice.isFetching[status] = isFetching;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getAllDataProjectManagement.pending, (state, action) => {
      // console.log("state: pending", state, action);
      // state.allProjectList.isFetching = {
      //   ...state.allProjectList.isFetching,
      // };
      const { serviceType = SERVICE_TABS.video } = action.meta.arg;
      const serviceSlice = getAllDataProjectManagementServiceSlice(
        state,
        serviceType
      );
      if (!serviceSlice) return;
      serviceSlice.isFetching = {
        ...serviceSlice.isFetching,
      };
    });

    builder.addCase(getAllDataProjectManagement.fulfilled, (state, action) => {
      // console.log("state: pending", state);
      // state.allProjectList.isFetching = {
      //   ...state.allProjectList.isFetching,
      // };

      const { serviceType = SERVICE_TABS.video } = action.meta.arg;
      const serviceSlice = getAllDataProjectManagementServiceSlice(
        state,
        serviceType
      );
      if (!serviceSlice) return;

      serviceSlice.isFetching = {
        ...serviceSlice.isFetching,
      };
    });

    builder.addCase(getAllDataProjectManagement.rejected, (state, action) => {
      console.log("state, action: ", state, action);
      // Handle general errors if needed
    });
  },
});

export const { updateProjectData, updateProjectError, updateFetchingStatus } =
  AllDataProjectManagementSlice.actions;

export default AllDataProjectManagementSlice.reducer;
